import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

export interface CrumbItem {
  label: string
  path: string
}

type Tone = 'dark' | 'light'

export default function Breadcrumbs({ items, tone = 'dark' }: { items: CrumbItem[]; tone?: Tone }) {
  const text = tone === 'dark' ? 'text-white/50' : 'text-primary-ink/50'
  const current = tone === 'dark' ? 'text-white/70' : 'text-primary-ink/70'
  const all: CrumbItem[] = [{ label: 'Home', path: '/' }, ...items]
  // On small screens with >3 levels, collapse middle items to an ellipsis.
  const collapsed = all.length > 3 ? [all[0], { label: '…', path: '' }, ...all.slice(-2)] : all
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      {/* Full trail at sm+, collapsed trail below sm */}
      <ol className={`hidden sm:flex flex-wrap items-center gap-1.5 font-display text-[11px] uppercase tracking-[0.2em] ${text}`}>
        {all.map((item, i) => {
          const last = i === all.length - 1
          return (
            <li key={`${item.path}-${i}`} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="h-3 w-3 text-accent-gold" aria-hidden="true" />}
              {last ? (
                <span aria-current="page" className={current}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.path} className="hover:text-accent-gold transition-colors">
                  {item.label}
                </Link>
              )}
            </li>
          )
        })}
      </ol>
      <ol className={`flex sm:hidden flex-wrap items-center gap-1.5 font-display text-[11px] uppercase tracking-[0.2em] ${text}`}>
        {collapsed.map((item, i) => {
          const last = i === collapsed.length - 1
          const isEllipsis = item.label === '…'
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="h-3 w-3 text-accent-gold" aria-hidden="true" />}
              {isEllipsis ? (
                <span aria-hidden="true">…</span>
              ) : last ? (
                <span aria-current="page" className={current}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.path} className="hover:text-accent-gold transition-colors">
                  {item.label}
                </Link>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
